/** Speech is a person's press; cancelling a sheet stops its utterance. No audio is retained. */
export function speakVisit(text: string, lang: 'en' | 'es', rate = 1) {
  if (!('speechSynthesis' in window)) return false;
  window.speechSynthesis.cancel(); const utterance = new SpeechSynthesisUtterance(text); utterance.lang = lang === 'es' ? 'es-US' : 'en-US'; utterance.rate = rate;
  const voice = window.speechSynthesis.getVoices().find((v) => v.lang.startsWith(lang)); if (voice) utterance.voice = voice;
  window.speechSynthesis.speak(utterance); return true;
}
export const stopVisitSpeech = () => { if ('speechSynthesis' in window) window.speechSynthesis.cancel(); };
